/**
     * 个人页模块 组件
     * personalInfo
     */
export default {
  name: 'personalInfo',
  props: {
    personalInfoList: Object,
    bindList: Array,
    isSelf: Boolean,
    target: String
  },
  methods: {
    // 获取性别
    getSexClassName: function getSexClassName(sex) {
      var className = 'user-sex';
      if (sex != 0) {
        className = 'user-sex male';
      }
      return className;
    },
    // 获取颜色
    getTagBgcolor: function getTagBgcolor(tag) {
      return "#".concat(tag.tag_color);
    },
    // 用户绑定的客户端
    getBindName: function getBindName(type) {
      switch (type) {
        case '101':
          return 'facebook';
        case '102':
          return 'youtube';
        case '103':
          return 'twitter';
        case '105':
          return 'instagram';
        case '108':
          return 'email';
        default:
          break;
      }
    },
    clickShowPop: function clickShowPop(pop, index) {
      this.$emit('clickShowPop', pop, index);
    },
    clickFollowFriend: function clickFollowFriend(uid, type, index) {
      this.$emit('clickFollowFriend', uid, type, index);
    }
  }
};